// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1330":"eda651012ebccbff","3038":"ebea8208b939091a"}[chunkId] + ".css";
};